import { Box, ModalBody } from "@chakra-ui/react";
import { useAppContext } from "../AppContext";

export const Tips: React.FC = (): JSX.Element => {
  const { isEnglish } = useAppContext();
  return (
    <ModalBody p={0} mt={"-5px"}>
      <Box overflowY="scroll" maxH="380px">
        {isEnglish ? (
          // ENGLISH TIPS
          <>
            {" "}
            <p>{`You could use the following 4 methods to search verses:`}</p>
            <br />
            <p>{`Example: Mark chapter 1 verse 1, Mark chapter 1 verse 1 to 10`}</p>
            <br />
            <p>
              <h1>
                <b>{`1. Space separation: `}</b>
              </h1>
              {`Mark \u00a0 1 \u00a0 1 \u00a0 or \u00a0 Mark \u00a0 1 \u00a0 1 \u00a0 10`}
            </p>
            <p>{`Use space to separate`}</p>
            <br />
            <p>
              <h1>
                <b>{`2. Normal verse format:`}</b>
              </h1>
              {` Mark1:1 \u00a0 or \u00a0 Mark1:1-10`}
            </p>
            <p>{`No space needed in this format`}</p>
            <br />
            <p>
              <h1>
                <b>
                  {`3. Whole Chapter:`}
                  {` Mark1 \u00a0 or \u00a0 Mark \u00a0 1`}
                </b>
              </h1>
            </p>
            <p>{`You could use space to separate the chapter and book name.`}</p>
            <br />
            <p style={{ color: "red" }}>
              <h1>
                <b>{`4. (New) Keyword Search:`}</b>
              </h1>
              {`Garden of Eden \u00a0 or \u00a0 Garden of Eden, God`}
            </p>
            <p style={{ color: "red" }}>{`Use comma (,) to separate ultiple keywords`}</p>
            <br />
            <p>{` * Book name could be abbrev or full book name`}</p>
          </>
        ) : (
          // CHINESE TIPS
          <>
            <p>{`你可以用以下4種方式搜索經文：`}</p>
            <p>{`例如: 創世記1章1節, 創世記1章1到10節`}</p>
            <br />
            <p>{`1. 空格法： 創 \u00a0 1 \u00a0 1 \u00a0 or \u00a0 創 \u00a0 1 \u00a0 1 \u00a0 10`}</p>
            <p>{`\u00a0\u00a0 中間用空格(space)隔開`}</p>
            <br />
            <p>{`2. 常見方法： 創1:1 \u00a0 or \u00a0 創1:1-10`}</p>
            <p>{`\u00a0\u00a0 這個方法沒有空格`}</p>
            <br />
            <p>{`3. 搜索一整章： 創1 \u00a0 or \u00a0 創 \u00a0 1`}</p>
            <p>{`\u00a0\u00a0 中間可用空格(space)隔開`}</p>
            <br />
            <p style={{ color: "red" }}>{`4. (New) 搜索關鍵字：伊甸園 \u00a0 or \u00a0 伊甸園，神`}</p>
            <p style={{ color: "red" }}>{`\u00a0\u00a0 多個關鍵字中間用逗號(comma)隔開`}</p>
            <br />

            <p>{` *書名可以全稱也可以簡稱`}</p>
            <p>{` *創世記的記/记 別打錯了喔！ ${String.fromCodePoint(0x1f602)}`}</p>
          </>
        )}
      </Box>
    </ModalBody>
  );
};
